"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMapSearchState2 = exports.defaultMapSearchState = void 0;
var defaultAggregatedData = [
    {
        id: 1,
        count: 2448,
        latitude: '22.2588',
        longitude: '114.1911',
        minPrice: 14,
        maxPrice: 1000,
        properties: null,
    },
    {
        id: 2,
        count: 231,
        latitude: '22.3186',
        longitude: '114.1796',
        minPrice: 19.8,
        maxPrice: 300,
        properties: null,
    },
    {
        id: 3,
        count: 206,
        latitude: '22.38817438',
        longitude: '114.20219421',
        minPrice: 18,
        maxPrice: 220,
        properties: null,
    },
    {
        id: 4,
        count: 111,
        latitude: '22.2665',
        longitude: '113.9418',
        minPrice: 13.5,
        maxPrice: 160,
        properties: null,
    }
];
var defaultCamera = {
    center: { lat: 22.3737373, lng: 114.1175171 },
    zoom: 10,
};
exports.defaultMapSearchState = {
    cacheData: null,
    clusterConfig: null,
    extraPins: null,
    mapInit: false,
    viewport: null,
    minZoom: 11,
    camera: null,
    currentActivePins: null,
    hideMap: false,
    initAggregatedData: [],
};
exports.defaultMapSearchState2 = {
    cacheData: null,
    clusterConfig: null,
    extraPins: null,
    mapInit: true,
    viewport: null,
    minZoom: 11,
    camera: {
        center: {
            lat: 22.355614785617274,
            lng: 114.10810200000003
        },
        zoom: 11
    },
    currentActivePins: null,
    hideMap: false,
    initAggregatedData: [
        {
            id: 1,
            count: 320,
            latitude: "22.2588",
            longitude: "114.1911",
            minPrice: 100,
            maxPrice: 600,
            properties: null
        },
        {
            id: 2,
            count: 14,
            latitude: "22.3186",
            longitude: "114.1796",
            minPrice: 100,
            maxPrice: 150,
            properties: null
        },
        {
            id: 3,
            count: 26,
            latitude: "22.38817438",
            longitude: "114.20219421",
            minPrice: 100,
            maxPrice: 276.9,
            properties: null
        },
        {
            id: 4,
            count: 5,
            latitude: "22.2665",
            longitude: "113.9418",
            minPrice: 100,
            maxPrice: 140,
            properties: null
        }
    ],
};
